// Feature-hover tooltip (A24/NG11, spec §5.1). Shows the label column + up to 4 attached properties,
// each value string-truncated. SANITIZED by construction: values render as React text nodes (no
// dangerouslySetInnerHTML) so no attribute/markup injection is possible. A transient popover — the
// panel clears it on Escape and on hover-leave.

const MAX_PROPERTY_ROWS = 4;
const MAX_VALUE_CHARS = 60;

function truncate(value: unknown): string {
  const s = typeof value === 'string' ? value : String(value);
  return s.length > MAX_VALUE_CHARS ? `${s.slice(0, MAX_VALUE_CHARS)}…` : s;
}

export function SpatialMapHoverTooltip({
  label,
  properties,
  x,
  y,
}: {
  label: string | null;
  properties: Array<{ key: string; value: unknown }>;
  x: number;
  y: number;
}) {
  const rows = properties.slice(0, MAX_PROPERTY_ROWS);
  if (!label && rows.length === 0) return null;
  return (
    <div
      data-testid="spatial-map-hover-tooltip"
      className="pointer-events-none absolute z-20 max-w-[240px] rounded-md border border-border/70 bg-popover/95 px-2 py-1 text-[11px] text-popover-foreground shadow-md backdrop-blur-sm"
      style={{ left: x + 12, top: y + 12 }}
    >
      {label !== null && <div className="mb-0.5 truncate font-medium">{truncate(label)}</div>}
      {rows.map((row) => (
        <div key={row.key} className="flex gap-1.5 leading-tight">
          <span className="truncate text-muted-foreground">{row.key}</span>
          <span className="truncate">{truncate(row.value)}</span>
        </div>
      ))}
    </div>
  );
}
